import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Páginas
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import ContractPage from './pages/ContractPage';
import WaterMonitoring from './pages/WaterMonitoring';
import PhotosPage from './pages/PhotosPage'; // Você ainda vai criar esta

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Rotas públicas */}
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/fotos" element={<PhotosPage />} />
          
          {/* Rotas protegidas (requer autenticação) */}
          <Route 
            path="/contratos/novo" 
            element={
              <ProtectedRoute>
                <ContractPage />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/agua" 
            element={
              <ProtectedRoute>
                <WaterMonitoring />
              </ProtectedRoute>
            } 
          />
          
          {/* Rota 404 ou redirect */}
          <Route path="*" element={<HomePage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;